import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import noEvent from '../../assets/images/waiting-img-.svg';
import tmdbApi from "../../api/tmdbApi";
import SweetAlert from "react-bootstrap-sweetalert";

const AwaitingForSession = ({ timer }) => {
  const [winners, setWinners] = useState([]);
      const [showFellowshipPopup, setShowFellowshipPopup] = useState(false);
      const [fellowshipUser, setFellowshipUser] = useState(null);
  const location = useLocation();
  const fetchWinners = async () => {
    try {
      const response = await tmdbApi.latestCpcTopWinners()
      if (typeof response?.result !== 'string') {
        console.log("response", response?.result)
        setWinners(response.result);
      }
    } catch (error) {
      console.error('Error fetching winners:', error);
    }
  }
      const checkFellowshipInterest = async () => {
          if (localStorage.getItem("fellowshipInterest") !== "true") return;
          if (!localStorage.getItem("token")) return;
          try {
              const response = await tmdbApi.getUserData();
              localStorage.removeItem("fellowshipInterest");
              setFellowshipUser(response?.result?.[0] || response?.result);
          } catch (error) {
              console.log(error);
          } finally {
              setShowFellowshipPopup(true);
          }
      };
          const handleFellowshipConfirm = async () => {
                  try {
                      await tmdbApi.userDataUpdate({
                          fellowshipInterest: true,
                          fellowshipInterestDate: localStorage.getItem("fellowshipInterestDate"),
                      });
                  } catch (error) {
                      console.log(error);
                  } finally {
                      localStorage.removeItem("fellowshipInterestDate");
                      setShowFellowshipPopup(false);
                  }
          };
  useEffect(() => {
    fetchWinners();
     checkFellowshipInterest()
  }, []);
  return (
    <div style={styles.container}>
      {winners && winners.length > 0 ? (
        <>
          {location?.pathname === '/' && (
            <h3 className="sub_title cpc-awating-title">
              Winners for Clinical Pathological Conferences
            </h3>
          )}
              <SweetAlert
                    show={showFellowshipPopup}
                    custom
                    confirmBtnText="OK"
                    confirmBtnBsStyle="primary"
                    title="Interest Registered"
                    
                    onConfirm={handleFellowshipConfirm}
                    id="fellowship-alert"
                ><p style={{fontSize: '14px'}}>Your interest has been registered. We will notify you when the fellowship structure and application process are formally announced.</p></SweetAlert>

          <div className="col-lg-12 row justify-content-center mt-3">
            <div className="col-lg-8 justify-content-start cpc-winner-block pb-1 p-0">
              <div className="col-lg-12 d-flex flex-column justify-content-start align-items-center">
                <div className="col-lg-12 p-2 d-flex justify-content-between align-items-center cpc-title-time-day">
                  <div className="cpc-title p-2">
                    <h4 className="fw-semibold m-0">
                      Congratulations to the Pre-CPC Quiz Winner's
                    </h4>
                  </div>

                  <div className="cpc-time-date d-flex align-items-center gap-2 pe-3">
                    <i className="fa-regular fa-calendar"></i>
                    <span>
                      {new Date(winners[0]?.cpcmeetingDate).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </span>
                  </div>
                </div>



                <table className="table cpc-awating-winner-table">
                  <thead>
                    <tr>
                      <th className="text-start">Participants</th>
                      <th className="text-start">Score</th>
                      <th className="text-start">Percentile</th>
                    </tr>
                  </thead>
                  <tbody>
                    {winners.map((winner, index) => (
                      <tr key={index}>
                        <td className="text-start">{winner?.username}</td>
                        <td className="text-start">
                          {winner?.cpcResult} / {winner?.casesCount}
                        </td>
                        <td className="text-start">
                          {winner?.percentileRank} / 100
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      ) : <> {location?.pathname === "/" &&
        <div>
          <h3 className="sub_title">Upcoming Featured Session: Live CPC</h3>
        </div>}
        <img src={noEvent} alt="No Events" className='waiting-img' style={styles.image} />
        <h2 style={styles.text}>Waiting for the next session</h2></>
      }
    </div>

  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '40px',
  },
  image: {
    width: '250px',
    height: 'auto',
    marginBottom: '20px',
  },
  text: {
    color: '#555',
    fontSize: '20px',
  },
};


export default AwaitingForSession;
